module.exports = __webpack_public_path__ + "static/media/i-done-circle-green.80cf2f60.svg";